// extracted by mini-css-extract-plugin
module.exports = {"table":"DefaultHotTable_table__2YRZw"};